import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { router } from './routes';
import { trackPageView } from './utils/analytics';

export default function App() {
  useEffect(() => {
    // Initial page load
    trackPageView(window.location.pathname + window.location.search);
    // Subsequent client-side navigations
    return router.subscribe((state) => {
      if (state.navigation.state === 'idle') {
        trackPageView(state.location.pathname + state.location.search);
      }
    });
  }, []);

  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: { fontSize: '14px' },
          success: { style: { background: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0' } },
          error: { style: { background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }, duration: 4000 },
        }}
      />
      <RouterProvider router={router} />
    </>
  );
}
